module.exports = __webpack_public_path__ + "img/134.6.4dcfca96.png";